import { Collapsible, CollapsibleItem } from "react-materialize";
import styles from "./VideoBlock.module.scss";

export const VideoBlock = () => {
  const src = `${"https://rutube.ru/channel/40516110"}`;
  const header =
    <div className={styles.videoblockHeaderContainer}>
      <svg
        fill="none"
        height="20"
        viewBox="-.141 .5 842.68 145.89"
        width="200"
        xmlns="http://www.w3.org/2000/svg" >
        <path
          d="m92.885 42.977h-93.026v103.413h25.892v-33.644h49.614l22.635 33.644h28.993l-24.962-33.799c7.752-1.241 13.334-4.187 16.745-8.838s5.116-12.093 5.116-22.016v-7.752c0-5.892-.62-10.543-1.705-14.109-1.086-3.566-2.946-6.667-5.582-9.457-2.791-2.636-5.891-4.497-9.612-5.737-3.721-1.085-8.373-1.705-14.11-1.705zm-4.186 46.977h-62.949v-24.186h62.95c3.566 0 6.046.62 7.287 1.705 1.238 1.085 2.013 3.101 2.013 6.047v8.682c0 3.101-.775 5.117-2.015 6.202s-3.722 1.55-7.287 1.55zm73.286 25.892v-72.87h-25.892v72.25c0 5.892.465 10.698 1.55 14.264 1.085 3.721 2.946 6.822 5.737 9.458 2.635 2.79 5.736 4.651 9.457 5.736 3.721 1.241 8.373 1.706 14.264 1.706h62.017c5.737 0 10.388-.465 14.109-1.706 3.721-1.085 6.822-2.946 9.613-5.736 2.635-2.636 4.496-5.737 5.581-9.458 1.085-3.566 1.706-8.372 1.706-14.264v-72.25h-25.893v72.87c0 3.101-.775 5.117-2.015 6.202s-3.721 1.551-7.287 1.551h-53.645c-3.721 0-6.201-.466-7.442-1.551-1.24-1.085-1.86-3.101-1.86-6.202zm185.728 30.544v-80.622h50.079v-22.791h-126.05v22.79h50.079v80.623zm87.578-30.544v-72.87h-25.892v72.25c0 5.892.465 10.698 1.551 14.264 1.085 3.721 2.945 6.822 5.736 9.458 2.636 2.79 5.737 4.651 9.458 5.736 3.721 1.241 8.372 1.706 14.264 1.706h62.017c5.736 0 10.387-.465 14.108-1.706 3.721-1.085 6.822-2.946 9.613-5.736 2.636-2.636 4.496-5.737 5.582-9.458 1.085-3.566 1.705-8.372 1.705-14.264v-72.25h-25.892v72.87c0 3.101-.775 5.117-2.016 6.202-1.24 1.085-3.721 1.551-7.287 1.551h-53.644c-3.721 0-6.202-.466-7.442-1.551-1.241-1.085-1.861-3.101-1.861-6.202zm229.358-42.791v-2.016c0-9.612-2.48-16.744-7.442-21.24-4.961-4.497-12.868-6.822-23.411-6.822h-87.909v103.413h93.025c10.543 0 18.45-2.171 23.412-6.667 4.961-4.496 7.442-11.628 7.442-21.241v-2.17c0-9.613-2.481-16.435-7.442-20.466-.931-.62-1.861-1.085-2.791-1.55a39.433 39.433 0 0 0 -4.031-1.706c3.411-1.86 5.736-4.341 7.132-7.132 1.24-2.79 2.015-6.977 2.015-12.403zm-92.87 11.318v-18.605h57.831c3.721 0 6.201.62 7.442 1.705 1.24 1.085 1.86 3.101 1.86 6.047v3.1c0 3.102-.62 5.117-1.86 6.202-1.241 1.086-3.721 1.55-7.442 1.55zm0 39.226v-18.606h63.102c3.566 0 6.047.621 7.287 1.706 1.241 1.085 2.016 3.101 2.016 6.047v3.1c0 3.101-.775 5.117-2.016 6.202-1.24 1.085-3.721 1.551-7.287 1.551zm133.106-57.831h84.653v-22.791h-110.545v103.413h114.731v-22.791h-88.839v-17.52h82.638l2.015-22.791h-84.653z"
          fill="#1c293e" />
        <circle
          cx="824.422"
          cy="18.617"
          fill="#f41240"
          r="18.117" />
      </svg>
      <p>Новости проекта:</p>
    </div>;
  return (
    <>
      <div className="container">
        <Collapsible
          accordion
          popout
        >
          <CollapsibleItem
            expanded={false}
            header={header}
            node="div"
          >
            <div className="video-container container">
              <iframe
                width="560"
                height="315"
                src={src}
                title="Rutube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </CollapsibleItem>
        </Collapsible >
      </div >
    </>
  );
};
